import { API } from 'aws-amplify';

import { ActionTree, ActionContext } from 'vuex';
import { RootState } from '../types';
import { ContractorsState } from './types';

import { Contractor } from '@/models';
import _ from 'lodash';
export const actions: ActionTree<ContractorsState, RootState> = {

	/**
	 * Get all Contractors
	 * 
	 * @param {ContractorsState} store
	 * @param filters
	 * @returns All Contractors
	 */
	async getContractors(store: ActionContext<ContractorsState, any>): Promise<Contractor[]> {
		store.commit('app/addRequest', 'getContractors', { root: true });

		return API.get('RestAPI', `/contractors`, {})
			.then((response) => response.map((x: Partial<Contractor>) => new Contractor(x)))
			.then((Contractor: Contractor[]) => {
				store.commit('setContractors', Contractor);
				return Contractor;
			})
			.finally(() => store.commit('app/removeRequest', 'getContractors', { root: true }));
	},

	/**
	 * Get one Contractor
	 * 
	 * @param {ContractorsState} store 
	 * @param id 
	 * @returns individual Contractor
	 */
	async getContractor(store: ActionContext<ContractorsState, any>, id) {
		// New Contractor
		if (id === 'new') {
			const contractor = new Contractor();
			store.commit('setCurrent', contractor);
			return contractor;
		}
		store.commit('app/addRequest', 'getContractor', { root: true });

		return API.get('RestAPI', `/contractors/${id}`, null)
			.then((response) => new Contractor(response))
			.then((Contractor: Contractor) => {
				store.commit('setCurrent', Contractor);
				return Contractor;
			})
			.finally(() => store.commit('app/removeRequest', 'getContractor', { root: true }));
	},

	/**
   * Add Contractor
   * 
   * @param {ContractorsState} store 
   * @param Contractor Contractor
   */
	async addContractors(store: ActionContext<ContractorsState, any>, contractor: Contractor): Promise<void> {
		store.commit('app/addRequest', 'addContractor', { root: true });
		return API.post('RestAPI', '/contractors', { body: contractor.toJSON() })
			.then((data) => new Contractor(data))
			.then((Contractorfromserver: Contractor) => {
				store.commit('resetUnsavedChanges');
			})
			.finally(() => store.commit('app/removeRequest', 'addContractor', { root: true }));
	},

	/**
   * Delete Contractor
   * 
   * @param {ContractorsState} store 
   * @param Contractor Contractor
   */
	async deleteContractors(store: ActionContext<ContractorsState, any>, Contractor: Contractor): Promise<void> {
		store.commit('app/addRequest', 'deleteContractor', { root: true });
		return API.del('RestAPI', `/contractors/${Contractor.id}`, {})
			.then(() => {
				store.commit('resetUnsavedChanges');
				store.commit('setContractors', _.remove(store.state.list, (c: Contractor) => c.id != Contractor.id));
			})
			.finally(() => store.commit('app/removeRequest', 'deleteContractor', { root: true }));
	},


	/**
   * Update given Contractor details
   * 
   * @param {ContractorsState} store 
   * @param Contractor Contractor
   */
	async updateContractors(store: ActionContext<ContractorsState, any>, contractor: Contractor): Promise<void> {
		store.commit('app/addRequest', 'updateContractor', { root: true });
		return API.put('RestAPI', `/contractors/${contractor.id}`, { body: contractor.toJSON() })
			.then((data) => new Contractor(data))
			.then((Contractor: Contractor) => {
				store.commit('setCurrent', Contractor);
				store.commit('resetUnsavedChanges');
			})
			.finally(() => store.commit('app/removeRequest', 'updateContractor', { root: true }));
	},

	/**
   * Sets any deep Contractor contractor and increments the "unsaved changes" count
   * @param store
   * @param data
   */
	setContractorsDeep(store: ActionContext<ContractorsState, any>, data): void {
		store.commit('setContractorsDeep', data);
		store.commit('addUnsavedChange');
	},

	/**
 * Set the page for the Reports query
 *
 * @param store
 * @param data
 */
	resetCurrentPage(store: ActionContext<ContractorsState, any>): void {
		store.commit('setCurrentPage', 1);
	},
}
